import useMediaQuery from "./useMediaQuery";

const useIsTablet = () => {
  return useMediaQuery("(min-width: 992px) and (max-width: 1328px)");
};

export default useIsTablet;
